import React from 'react';

import styled from '@emotion/styled';

import { useAppSelector } from '../../redux/store';
import PadlockIcon from '../Icons/PadlockIcon';

interface KycRequiredBlurCardProps {
  children?: React.ReactNode;
  message: string;
}

const KycRequiredBlurCard: React.FC<KycRequiredBlurCardProps> = ({
  children,
  message,
}) => {
  const { kycStatusData } = useAppSelector((state) => state.kycStatusData);

  return (
    <Container>
      {children}
      {!['Accepted'].includes(kycStatusData?.kycStatus ?? '') && (
        <Blur>
          <ContentArea>
            <PadlockIcon />
            <div>{message}</div>
          </ContentArea>
        </Blur>
      )}
    </Container>
  );
};

export default KycRequiredBlurCard;

const Container = styled.div`
  display: grid;

  & > * {
    grid-column: 1;
    grid-row: 1;
  }
`;

const Blur = styled.div`
  z-index: 50;
  margin: 2px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  background-color: rgba(255, 255, 255, 0.1);

  cursor: default;
`;

const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;
